import { MediaMetadata } from './media-metadata';
import { MetaEventArgs } from './meta-event-args';

export enum MetadataType {
    DateRange = 'date-range',
    Id3 = 'id3',
    Media = 'media',
    ProgramDateTime = 'program-date-time',
    Scte35 = 'scte-35',
    Unknown = 'unknown'
}

// TODO: define interfaces for Id3 Metadata, for now we keep any
export type Id3Metadata = any;
export type MediaMetadataEventArgs = MetaEventArgs & MediaMetadata;

